module.exports = "/_next/static/images/uv-layer-1-c902f1d725ae0d33c68b91a818401cf2.png";